module.exports = __webpack_public_path__ + "static/media/footer-background.b71fd79b.svg";